export default __webpack_public_path__ + "static/media/sidebar-3.e667b13e.jpg";